// extracted by mini-css-extract-plugin
module.exports = {"container":"category_container__kCdXZ","ios":"category_ios__xCCx_","android":"category_android__q6QDd","link":"category_link__yWaYb"};